/* Gujoy — comportements des pages reproduites (compte à rebours, barre fixe, offres de la fiche) */
(function(){
  if(window.__gjInit) return; window.__gjInit=true;
  // Compte à rebours jusqu'à minuit (heure du téléphone), comme sur Gujoy
  function tick(){
    var now=new Date(), end=new Date(now); end.setHours(24,0,0,0);
    var s=Math.max(0,Math.floor((end-now)/1000)), h=Math.floor(s/3600), m=Math.floor(s%3600/60), x=s%60;
    var v={h:h,m:m,s:x};
    document.querySelectorAll('[data-gj-cd]').forEach(function(el){
      ['h','m','s'].forEach(function(k){var n=el.querySelector('[data-'+k+']'); if(n) n.textContent=String(v[k]).padStart(2,'0');});
    });
  }
  tick(); setInterval(tick,1000);

  // Barre fixe téléphone : visible entre deux repères
  function sticky(){
    var bar=document.querySelector('.gj-sticky'); if(!bar) return;
    var from=document.querySelector(bar.dataset.from||'[data-gj-sticky-from]'), to=document.querySelector(bar.dataset.to||'[data-gj-sticky-to]');
    function upd(){
      var y=window.innerHeight, a=from?from.getBoundingClientRect().top<y:true, b=to?to.getBoundingClientRect().top<y*0.85:false;
      bar.classList.toggle('is-on',a&&!b);
    }
    window.addEventListener('scroll',upd,{passive:true}); upd();
  }
  if(document.readyState!=='loading') sticky(); else document.addEventListener('DOMContentLoaded',sticky);

  // Fiche produit : galerie, offres, ajout au panier avec cadeaux, onglets ingrédients, barre fixe
  function pdp(){
    document.querySelectorAll('[data-gj-pdp]').forEach(pdpOne);
  }
  function pdpOne(root){
    var track=root.querySelector('.gj-gal__track'), ths=root.querySelectorAll('.gj-gal__th');
    ths.forEach(function(b){b.addEventListener('click',function(){track.scrollTo({left:track.clientWidth*(+b.dataset.i),behavior:'smooth'});});});
    if(track) track.addEventListener('scroll',function(){var i=Math.round(track.scrollLeft/track.clientWidth); ths.forEach(function(b,k){b.classList.toggle('is-on',k===i);});},{passive:true});
    var form=root.querySelector('[data-gj-form]');
    if(!form){ var tb=root.querySelector('[data-gj-tabs]'); if(tb) tb.addEventListener('click',function(e){var b=e.target.closest('button'); if(!b) return; tb.querySelectorAll('button').forEach(function(x){x.classList.toggle('is-on',x===b);}); root.querySelectorAll('.gj-ing').forEach(function(c){c.hidden=!(b.dataset.f==='all'||c.dataset.k===b.dataset.f);});}); return; }
    form.querySelectorAll('input[name=id]').forEach(function(r){r.addEventListener('change',function(){
      form.querySelectorAll('.gj-offer-c').forEach(function(c){c.classList.toggle('is-on',c.contains(r)&&r.checked);});
    });});
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var sel=form.querySelector('input[name=id]:checked'); if(!sel) return;
      var items=[];
      if(sel.dataset.best==='1'&&root.dataset.gifts){ root.dataset.gifts.split(',').forEach(function(id){ if(id) items.push({id:+id,quantity:1}); }); }
      items.push({id:+sel.value,quantity:1});
      var btn=form.querySelector('[data-gj-atc]'), err=form.querySelector('[data-gj-err]'); btn.disabled=true; err.hidden=true;
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json().then(function(j){if(!r.ok) throw j; return j;});})
        .then(function(){ btn.disabled=false; if(window.gjCart){ return gjCart.refresh().then(gjCart.open); } window.location.href=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart'; })
        .catch(function(j){ btn.disabled=false; err.textContent=(j&&(j.description||j.message))||'Une erreur est survenue, réessaie.'; err.hidden=false; });
    });
    var tabs=root.querySelector('[data-gj-tabs]');
    if(tabs) tabs.addEventListener('click',function(e){var b=e.target.closest('button'); if(!b) return;
      tabs.querySelectorAll('button').forEach(function(x){x.classList.toggle('is-on',x===b);});
      root.querySelectorAll('.gj-ing').forEach(function(c){c.hidden=!(b.dataset.f==='all'||c.dataset.k===b.dataset.f);});
    });
    var ba=root.querySelector('[data-gj-ba]'); if(ba){ var bt=ba.querySelector('.gj-ba__track'); ba.addEventListener('click',function(e){var b=e.target.closest('[data-ba]'); if(!b) return; bt.scrollBy({left:bt.clientWidth*(+b.dataset.ba),behavior:'smooth'});}); }
    var st=root.querySelector('[data-gj-psticky]'), atc=form.querySelector('[data-gj-atc]');
    if(st&&atc){ var upd=function(){ st.classList.toggle('is-on', atc.getBoundingClientRect().bottom<0); }; window.addEventListener('scroll',upd,{passive:true}); upd(); }
  }
  if(document.readyState!=='loading') pdp(); else document.addEventListener('DOMContentLoaded',pdp);

  // Panier : cadeaux à 1 exemplaire et seulement avec l'offre « Achète 2, le 3e offert »
  function guardGifts(){
    var root=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/');
    fetch(root+'cart.js').then(function(r){return r.json();}).then(function(c){
      var ok=c.items.some(function(i){return i.product_type!=='Cadeau'&&/^Ach[eè]te 2/i.test((i.variant_options||[])[0]||'');});
      var upd={}, need=false;
      c.items.forEach(function(i){ if(i.product_type==='Cadeau'){ var q=ok?1:0; if(i.quantity!==q){upd[i.key]=q; need=true;} } });
      if(need) fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:upd})}).then(function(){ if(/\/cart\/?$/.test(location.pathname)) location.reload(); });
    });
  }
  // Popup « pot offert » (quiz), une fois par session
  (function(){ var pop=document.querySelector('[data-gj-pop]'); if(!pop) return; var seen=false; try{seen=sessionStorage.getItem('gj_pop');}catch(e){}
    if(seen) return; setTimeout(function(){ pop.hidden=false; try{sessionStorage.setItem('gj_pop','1');}catch(e){} },7000);
    pop.addEventListener('click',function(e){ if(e.target===pop||e.target.closest('[data-gj-pop-close]')) pop.hidden=true; }); })();
  guardGifts();
  document.addEventListener('change',function(e){ if(e.target.closest&&e.target.closest('cart-items')) setTimeout(guardGifts,1200); });
  document.addEventListener('click',function(e){ if(e.target.closest&&e.target.closest('cart-remove-button')) setTimeout(guardGifts,1200); });
})();
